import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect, useState } from "react";

import { NextSeo } from "next-seo";
import axios from "axios";

import useStore from "@store/store";
import {
	selectAccountDataActions,
	selectCreditBalance,
} from "@store/slices/accountSlice";
import { selectArchiveDataActions } from "@store/slices/archiveSlice";

import { useUser } from "../utils/AuthContext";
import { UserDashboard } from "@components/Dashboard";
import { EXCEL_BOT_TOKEN } from "../utils/constants";

const Dashboard = () => {
	const { user, loading } = useUser();
	const {
		query: { session_id },
		push,
	} = useRouter();

	const { setAccountData, setOldStripeData } = useStore(
		selectAccountDataActions
	);
	const { setAllQueries, setAllVba } = useStore(selectArchiveDataActions);
	const creditBalance = useStore(selectCreditBalance);

	const [isLoadingData, setIsLoadingData] = useState<boolean>(false);

	useEffect(() => {
		if (loading) {
			setIsLoadingData(true);
		}

		if (user && !session_id && user?.uid) {
			setIsLoadingData(true);

			axios
				.post(
					`/api/data`,
					{ id: user.uid, email: user.email },
					{
						headers: {
							// @ts-ignore
							Authorization: `Bearer ${user.accessToken}`,
							ExcelBotToken: EXCEL_BOT_TOKEN,
						},
					}
				)
				.then((res) => {
					setAccountData(res.data.account);
					setAllQueries(res.data.all);
					setAllVba(res.data.vba);
					setOldStripeData(res.data.oldStripeData);
				})
				.catch((err) => {
					console.log(err);
					alert(err.message);
				});

			setIsLoadingData(false);
		}
	}, [
		user,
		session_id,
		creditBalance,
		push,
		loading,
		setAccountData,
		setAllQueries,
		setAllVba,
		setOldStripeData,
	]);

	useEffect(() => {
		if (session_id && user) {
			push("/dashboard");
		}
	}, [push, session_id, user]);

	return (
		<>
			<NextSeo
				title="Dashboard | AI Excel Bot"
				description="AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results."
				canonical="https://aiexcelbot.com/dashboard"
				openGraph={{
					url: "https://aiexcelbot.com/dashboard",
					title: "Dashboard | AI Excel Bot",
					description:
						"AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
					images: [
						{ url: "https://aiexcelbot.com/dashboard-hero.png" },
					],
					siteName: "AI Excel Bot",
				}}
				twitter={{
					handle: "@0x_gautam",
					cardType: "summary_large_image",
				}}
			/>

			<Script id="g-tag-conversion">{`gtag('event', 'conversion', {'send_to': 'AW-10784667441/oWPKCKeWnYUYELHuw5Yo'}); `}</Script>

			<main className="max-w-[1920px] m-auto">
				{!loading ? (
					<>
						{user ? (
							<UserDashboard isLoading={isLoadingData} />
						) : (
							<div className="h-screen w-screen flex items-center justify-center">
								<button
									className="btn btn-error"
									onClick={() => push("/login")}
								>
									Login to access Dashboard
								</button>
							</div>
						)}
					</>
				) : (
					<div className="h-screen flex justify-center items-center">
						<progress className="progress progress-success w-56"></progress>
					</div>
				)}
			</main>
		</>
	);
};

export default Dashboard;
